/**
 * Admin user API gender alanı string (ör. male/female, MALE/FEMALE, Erkek/Kadın),
 * sayı (0/1) ya da boolean dönebiliyor; düzenleme formu ve PATCH body için
 * male | female | null'a çevrilir.
 */
export function normalizeStaffGender(raw: unknown): "male" | "female" | null {
  if (raw == null) return null;

  // Numeric mapping (bazı backend sürümlerinde 0=male, 1=female)
  if (typeof raw === "number") {
    if (raw === 0) return "male";
    if (raw === 1) return "female";
    return null;
  }

  const s = String(raw).trim().toLowerCase();
  if (!s) return null;

  if (s === "male" || s === "m" || s === "erkek" || s === "0") return "male";
  if (
    s === "female" ||
    s === "f" ||
    s === "kadın" ||
    s === "kadin" ||
    s === "1"
  ) {
    return "female";
  }

  return null;
}
